import React, { useContext } from 'react'
import PropTypes from 'prop-types'
import { SEARCH, SearchContext } from "../SearchContext"
import AgeField from '../fields/AgeField'

import { isBookingAgent } from '../../helpers/userHelper'

const AdvancedSearchPanel = ({
  open,
  toggleOpen
}) => {
  const { state: {
    rooms,
    roomsData,
    childrenAges,
    children,
    leadId,
    user,
    searchBy
  }, dispatch } = useContext(SearchContext)
  const _setLeadId = (payload) => dispatch({ type: SEARCH.LEAD_ID.SET, payload })

  const _togglePanel = (e) => {
    e.preventDefault()
    toggleOpen(!open)
  }

  const _displayKidsAgesForRoom = (roomIdx, kids) => {
    const kidsAges = Array.from({ length: kids }, (_, i) => {
      return (
        <AgeField index={i} key={i} roomIdx={roomIdx} />
      )}
    )
    return <div className="kids-group">{kidsAges}</div>
  }

  const _displayKidsAges = () => {
    if (rooms == 1) {
      if (children > 0) {
        return (
          <React.Fragment key={`room-ages-group-0`}>
            <p className="rooms-kids-group-label">Room 1:</p>
            {_displayKidsAgesForRoom(1, children)}
          </React.Fragment>
        )
      }
    } else {
      const roomsWithKids = roomsData.map((room, i) => {
        if (room.kids > 0) {
          return (
            <React.Fragment key={`room-ages-group-${i}`}>
              <p className="rooms-kids-group-label">Room {room.id}:</p>
              {_displayKidsAgesForRoom(room.id, room.kids)}
            </React.Fragment>
          )
        } else {
          return null
        }
      }).filter(room => room)

      return <>{roomsWithKids}</>
    }
  }

  const _updateLeadId = e => {
    let value = e.currentTarget.value
    _setLeadId(value)
  }

  return (
    <div
      className={`advanced-search-panel search-data-panel ${open ? "open" : ''}`}
      >
      <button
        role="button"
        className="plain text close"
        onClick={_togglePanel}
        >
        <i className="fas fa-chevron-up" />
      </button>
      <div className="fields">
        {isBookingAgent(user) && (
          <label
            className="lead-id">
            <span>Lead ID</span>
            <input
              type        = "text"
              name        = "lead-id"
              placeholder = "Zoho Lead ID"
              value       = {leadId}
              onChange    = {_updateLeadId}
              />
          </label>
        )}

        {(searchBy.country && searchBy.country !== 'US' && children > 0) && (
          <p className="ai-age-enter-disclaimer">
            You are searching for availability in a destination that has All Inclusive (AI) rates. For children, these rates vary based upon their age. To proceed, please enter the age of each child that is traveling
          </p>
        )}
        { _displayKidsAges() }
      </div>
    </div>
  )
}

AdvancedSearchPanel.propTypes = {
  open: PropTypes.bool.isRequired,
  toggleOpen: PropTypes.func.isRequired
}

export default AdvancedSearchPanel
